import React from 'react';
import { BookOpen } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-brand-dark/80 backdrop-blur-md border-b border-white/5" data-id="element-173">
      <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between" data-id="element-174">
        <div className="flex items-center gap-2" data-id="element-175">
          <BookOpen className="w-6 h-6 text-brand-gold" data-id="element-176" />
          <span className="font-heading font-bold text-lg md:text-xl tracking-tight" data-id="element-177">
            BIBLIOTECAS <span className="text-brand-gold" data-id="element-178">DIGITALES™</span>
          </span>
        </div>
        <div className="hidden md:block" data-id="element-179">
          <Button variant="primary" size="sm" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-180">
            VER PACKS
          </Button>
        </div>
      </div>
    </header>;
}